<template>
  <div class="unscheduled-treatment-pg">
    <h2 class="page-title">
      ASAP List
    </h2>
    <b-row>
      <b-col sm="12" md="12" lg="8" xl="6" class="px-xl-3 mb-3">
        <!--<b-card class="border-0 unscheduled-treatment-card-wrap h-100">-->
        <b-card class="border-0 overdue-recall-card-wrap h-100">
          <b-row>
            <b-col md="6">
              <div>
                  <p class="fw-semi-bold mb-1 w-100 px-2 py-1 fs-14 plan_providers">Appointment Status:</p>
                    <multiselect
                        v-if="providers"
                        v-model="selectedAptStatuses"
                        :options="aptStatusOptions"
                        :multiple="true"
                        :taggable="false"
                        :show-labels="false"                                                
                        label="name"
                        track-by="value"
                        aria-placeholder="Select Apt Status"
                    >                    
                    </multiselect>
              </div>
              <div class="mt-2">
                <p class="fw-semi-bold mb-1 w-100 px-2 py-1 fs-14 plan_providers">Availability:</p>
                <b-form-group class="abc-checkbox">
                    <b-form-checkbox
                        v-model="asapDays" 
                        value="Mon"
                        unchecked-value="FALSE"                                        
                    >
                        <span class="fw-semi-bold">Mon</span>
                    </b-form-checkbox>

                    <b-form-checkbox
                        v-model="asapDays"           
                        value="Tue" 
                        unchecked-value="FALSE"
                    >
                        <span class="fw-semi-bold">Tue</span>
                    </b-form-checkbox>

                    <b-form-checkbox    
                        v-model="asapDays"                    
                        value="Wed"
                        unchecked-value="FALSE"                                        
                    >
                        <span class="fw-semi-bold">Wed</span>
                    </b-form-checkbox>

                    <b-form-checkbox     
                        v-model="asapDays"                           
                        value="Thur"
                        unchecked-value="FALSE"                                        
                    >
                        <span class="fw-semi-bold">Thur</span>
                    </b-form-checkbox>

                    <b-form-checkbox      
                        v-model="asapDays"                          
                        value="Fri"
                        unchecked-value="FALSE"                                        
                    >
                        <span class="fw-semi-bold">Fri</span>
                    </b-form-checkbox>

                    <b-form-checkbox            
                        v-model="asapDays"
                        value="Sat"                    
                        unchecked-value="FALSE"                                        
                    >
                        <span class="fw-semi-bold">Sat</span>
                    </b-form-checkbox>
                </b-form-group>         
              </div>
            </b-col>

            <b-col md="6">
              <div class="mb-4 mt-3 mt-md-0">
                <p class="fw-semi-bold mb-1 px-2 w-100 py-1 fs-14 plan_filter">Code</p>
                
                <multiselect
                  v-if="codeOptions"
                  v-model="selectedCodes"
                  :options="codeOptions"
                  :multiple="true"
                  :taggable="false"
                  :show-labels="false"
                  :custom-label="codeWithDesc"
                  label="ProcCode"
                  track-by="ProcCode"
                  aria-placeholder="Add Options"
                 
                >
                  <template slot="tag" slot-scope="props">
                    <span class="custom__tag">
                      <span>{{props.option.ProcCode}}</span>
                      <i
                        tabindex="1"
                        class="multiselect__tag-icon"
                        @click="removeCode(props.option)"
                      ></i>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <div class="option__title d-flex">
                        <span class="option-code">{{ codeWithDesc(props.option) }}</span>
                      </div>
                    </div>
                  </template>
                </multiselect>

              </div>

              <div>
                  <p class="fw-semi-bold mb-1 w-100 px-2 py-1 fs-14 plan_providers">Providers:</p>

                <multiselect
                  v-if="providers"
                  v-model="selectedProviders"
                  :options="providers"
                  :multiple="true"
                  :taggable="false"
                  :show-labels="false"
                  :custom-label="providerCustomLabel"
                  label="FName"
                  track-by="ProvNum"
                  aria-placeholder="Select a Provider"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span class="custom__tag">
                      <img
                        class="option__image"
                        src="../../assets/icons-user-40.png"
                        alt="Team member image"
                      />
                      <span>{{ providerCustomLabel(props.option) }}</span>
                      <i tabindex="1" class="multiselect__tag-icon" @click="removeProvider(props.option)"></i>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <img
                      class="option__image"
                      src="../../assets/icons-user-40.png"
                      alt="Team member image"
                    />
                    <div class="option__desc">
                      <span class="option__title">{{ providerCustomLabel(props.option) }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              <p/>
            </b-col>
          </b-row>
          <b-button variant="success" type="submit" class="btn-sm mb-2" @click="applyFilter">Apply Filters</b-button>
        </b-card>
      </b-col>
      <b-col sm="12" md="5" lg="4" xl="3" class="px-xl-3 mb-3">
        
      </b-col>
      <b-col sm="12" md="7" lg="12" xl="3" class="px-xl-3 mb-3">
        
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <div class="modern-table-panel">
          <div class="panel-header">
            <h5 class="section-title">
              <i class="fa fa-list section-icon"></i>
              ASAP Patients
            </h5>
            <p class="panel-subtitle">Patients on the ASAP list waiting for appointment openings.</p>
          </div>
          <div class="table-content">
            <ErrorDisplay/>
            <AdminTable v-if="asapList" :data="asapList" :columns="columns" :options="options" :extra="getExtraParams('asap-list')"/>
          </div>
        </div>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>
/* eslint-disable */

import Vue from "vue";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import Widget from "@/components/Widget/Widget";
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import $ from "jquery";
import CommonQueries from '../../sql/queries';
import { mapState, mapActions, mapMutations } from 'vuex';
import moment from 'moment-timezone';
import _ from 'lodash';
import mixin from '../../mixin.js';
import AdminTable from '@/pages/Admin/AdminTable';

export default {
  name: 'AsapList',
  components: { DatePicker, Multiselect, Widget, ErrorDisplay, AdminTable },  
  mixins: [mixin],

  created() {    
    this.init();    
  },

  mounted() {    
  },

  data() {
    return {      
      results: [],            
      aptStatus: '',
      asapDays: [],
      selectedProviders: [],
      aptStatusOptions: [
        {
          name: 'Unscheduled',
          value: '3'
        },
        {
          name: 'Scheduled',
          value: '1'
        },
        {
          name: 'Planned',
          value: '6'
        },
        {
          name: 'Broken',
          value: '5'
        },
      ],
      selectedAptStatuses: [],
      selectedCodes: [],
      options: {
          filterable: [],
          skin:'table',
          sortable: [],
          perPage: 5,
          sortByColumn: false,
          pagination: { chunk: 5, dropdown: false },          
          //columnsClasses: {id:'w'}
        },
    };
  },
  methods: {
    ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored', 'setMessage']),
    ...mapActions('teamio', ['runQuery']),
    ...mapActions('lists',['createList']),
    ...mapActions('customer', ['getSites', 'getEmployees', 'getSettings']),
    ...mapMutations('teamio', ['emptyResults']),
    ...mapMutations('lists', ['setLists', 'setList']),

    async init() {           
      let query = {
          type: 'ASAP_LIST',
          siteID: this.siteID,          
          procCodes: _.map(this.selectedCodes, 'ProcCode'),
          providers: _.map(this.selectedProviders,'ProvNum'),
          aptStatus: _.map(this.selectedAptStatuses, 'value'),
          availableDays: this.asapDays
        };

        this.emptyResults();
        console.log('query', query);

        this.results = await this.runQuery(query);
    },

    isEmpty(obj) {
      for(var key in obj) {
          if(obj.hasOwnProperty(key))
              return false;
      }
      return true;
    },

    applyFilter() {      
      this.init();
    },

    removeCode(option) {
      let removeIdx = this.selectedCodes.findIndex(each => {
        return each.ProcCode === option.ProcCode;
      });
      this.selectedCodes.splice(removeIdx, 1);
    },

    removeProvider(option) {
      let removeIdx = this.selectedProviders.findIndex(each => {
        return each.ProvNum === option.ProvNum;
      });
      this.selectedProviders.splice(removeIdx, 1);
    },    

    codeWithDesc({ ProcCode, Descript }){
      return `${ProcCode} — [${Descript}]`;
    },

    providerCustomLabel({FName, MI, LName, Suffix, Abbr}) {
      return `${FName} ${MI} ${LName} ${Suffix} (${Abbr})`;
    },

    planOptionsWithCount({CarrierName, totalplans}) {
      return `${CarrierName} (${totalplans})`;
    },

    employeesCustomLabel({Name}) {
      return `${Name}`;
    },

    successCountDownChanged(count) {
        this.setDismissSuccessCountDown(count);
    },
    
  },

  computed: {
    ...mapState({
        _list: state => state.lists.list,
    }),

    dataToDisplay() {
      if(this.results && this.results.data && this.results.data.length > 0)
          return this.results.data;
    },

    columns() {
      return ['AppointmentDate', 'AptNum', 'AptStatus', 'AvailableDays', 'Note', 'Patient', 'ProcCode', 'ProcDescript', 'Provider'];
    },

    filterableColumns() {
      return [];
    },

    codeOptions() {
      if(this.dataToDisplay)
        return this.dataToDisplay[0];
      else
        return [];
    },

    asapList() {
      if(this.dataToDisplay) {
        let temp = this.dataToDisplay[1];

        return temp;
      }
      else
        return [];
    }

  },

  watch: {
      getDefaultProvider(newValue, oldValue) {
        //console.log(`default provider changed. New value: ${JSON.stringify(newValue)}, Old value: ${JSON.stringify(oldValue)}`);
        if(!oldValue) {
          this.init();
        }
      }
  }
};
</script>

<style lang='scss'>

/* This is a fix for when the close button wasn't aligned properly */


.alert .close {
	position: relative !important;
  right: -16px !important;
  top: -16px !important
}
.VuePagination{
  flex-direction: row-reverse;
  float: right;
  margin: 0 !important;
  padding: 0 !important;
}
.abc-checkbox > div{
  display: block !important;
}
.help{
  position: absolute;
  right: 45px;
  top: 50px;
}
  button.close{
    position: relative !important; 
    right: 15px !important;
  }
  .table td{
    padding-top: 5px !important;
  }
.table-responsive .VueTables__table thead tr th{
  /*background-color: #4a4e50 !important;*/
  margin-left: auto !important;
  margin-right: auto !important;
  font-size: 12px !important;
  vertical-align: top !important;
}

.table-responsive .VueTables__table thead tr th{
  vertical-align: top !important
}

/* Below is to fix the issue where sorting icon was showing up on next line vs next to the column heading */
.table-responsive .VueTables__table .VueTables__heading {
    float: left;
}

table > thead > tr > th{
  text-transform: capitalize !important;
}
.VueTables__search-field{
  display: flex;

  label{
    margin-right: 10px
  }
}
.overdue-recall-table-section .card-body .overdue-recall-table-section-header{
  margin: 10px 0 0 !important;
}

.overdue-recall-table-section .card-body .overdue-recall-table-section-header[data-v-786b417f] {
    display: inline !important; 
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: flex-start;
    margin: 10px 0 35px;
    -webkit-box-align: center;
    -ms-flex-align: center;
}

.multiselect__select{
  max-height: 34px !important;
}

</style>
<style src="./AsapList.scss" lang="scss" scoped />

